import { createValidator, richTextMaxLength } from 'util/validation'

import { SubjetivoFormModel } from './SubjetivoForm'

export const subjetivoValidator = createValidator<SubjetivoFormModel>({
  texto: [richTextMaxLength(4000)],
})
